import React from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Team from "@/components/Team";
import WhyX10 from "@/components/WhyX10";
import Careers from "@/components/Careers";
import News from "@/components/News";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function Home() {
  return (
    <div data-testid="home-page" className="font-body bg-white text-slate-900">
      <SEO path="/" />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <About />
        <Team />
        <WhyX10 />
        <Careers />
        <News />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
